import { Text } from '@mercai/clever'

import { SectionHeaderProps } from './section-header.type'

import styles from './section-header.module.css'

export const SectionHeader = ({ title, children }: SectionHeaderProps) => {
  return (
    <div className={styles.core}>
      {typeof title === 'function' ? (
        title
      ) : (
        <div className={styles['section-header-title']}>
          <Text variant="title-medium">{title}</Text>
        </div>
      )}
      {children}
    </div>
  )
}
